import { styled } from "styled-components";

export const Margin = styled.div`
  margin-left: 10px;
`;
